import { OrderStatus } from '@/coreDomainsModule/entities/arrival';

/**
 * OrderStatusに関するロジックのサービス
 */
export class OrderStatusService {
  /**
   * OrderStatusを変更する際にユーザーに確認が必要かどうかを返す
   * @param orderStatus - OrderStatus
   * @param beforeOrderStatus - １つ前のOrderStatus
   */
  static isUserConfirmationRequiredForChange(orderStatus: OrderStatus, beforeOrderStatus: OrderStatus) {
    switch (beforeOrderStatus) {
      case OrderStatus.ApprovalRequested:
        return orderStatus === OrderStatus.Recommended;
      case OrderStatus.ApprovedAwaitingDeliveryDate:
        return orderStatus === OrderStatus.ApprovalRequested || orderStatus === OrderStatus.Recommended;
      default:
        return false;
    }
  }

  /**
   * OrderStatusに応じた有効な遷移先のOrderStatusを返す
   * @param orderStatus - OrderStatus
   */
  static getEnabledNextOrderStatus(orderStatus: OrderStatus): OrderStatus[] {
    switch (orderStatus) {
      case OrderStatus.Recommended:
      case OrderStatus.ApprovalRequested:
      case OrderStatus.ApprovedAwaitingDeliveryDate:
        return [OrderStatus.Recommended, OrderStatus.ApprovalRequested, OrderStatus.ApprovedAwaitingDeliveryDate];
      default:
        return [];
    }
  }

  /**
   * 発注を削除する際にユーザーに確認が必要かどうかを返す
   * @param orderStatus - OrderStatus
   */
  static isUserConfirmationRequiredForDelete(orderStatus: OrderStatus) {
    return orderStatus === OrderStatus.ApprovedAwaitingDeliveryDate || orderStatus === OrderStatus.ApprovalRequested;
  }

  /**
   * OrderStatusを更新する際にロックが必要かどうかを返す
   * ステータスの変更があった場合、新しいステータスがRecommended以外であればtrue（ロック必要）を返す
   * @param orderStatus - OrderStatus
   */
  static shouldLockOrderWhenUpdateOrderStatus(orderStatus: OrderStatus) {
    return orderStatus !== OrderStatus.Recommended;
  }

  /**
   * 発注日を計算する必要があるかどうかを返す
   * @param orderStatus - OrderStatus
   */
  static shouldCalculateCreatedOrderDate(orderStatus: OrderStatus) {
    // 発注日を計算する必要があるのは、承認依頼、承認済以外の状態
    return orderStatus !== OrderStatus.ApprovalRequested && orderStatus !== OrderStatus.ApprovedAwaitingDeliveryDate;
  }
}
